/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import { SvgHandler } from '../../../../svg-handler/svg-handler';
import closeIcon from '../../../../../../assets/icons/social/close.svg';
import { getDarkModeStyle } from '../../../login/util';
import './toast-message.m.css';

export const ToastMessage = ({ message, onClose }) => {
  const mode = getDarkModeStyle();
  return (
    <div styleName={`content-wrapper ${mode}`}>
      <span styleName='message'>{message}</span>
      <div styleName='close-icon' onClick={() => onClose()}>
        <SvgHandler width='24' height='24' xlinkHref={closeIcon} />
      </div>
    </div>
  );
};
